// extracted by mini-css-extract-plugin
module.exports = {"icon-with-text":"iconWithLink_icon-with-text__3TCIk","icon":"iconWithLink_icon__2lfHW","copy-icon":"iconWithLink_copy-icon__3U8wq"};